export default {
      id: "link-arrow-usage",
      viewBox: "0 0 16 10",
      url: "/" + "sprite.svg#link-arrow",
      toString: function () {
        return this.url;
      }
    }